import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CancelIcon from '@mui/icons-material/Cancel';
import Grid from "@mui/material/Grid";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Stack from "@mui/material/Stack";
import HomeButton from "../component/HomeButton";

function ErrorUrl() {
  const heightDisplay = window.innerHeight;
  const boxSize = heightDisplay - 210;

  return (
    <Container>
      <Box
        sx={{
          padding: "1rem",
          borderRadius: "16px",
          bgcolor: "#f5f6fa",
          height: boxSize + "px",
          overflow: "auto",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{ marginTop: "3rem", marginBottom: "1rem" }}
        >
          <CancelIcon
            sx={{ color: "red", width: "20%", height: "20%" }}
          />
        </Grid>
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          התקבלה תקלה בביצוע תשלום
        </Typography>
        <Typography variant="h5" sx={{ textAlign: "center" }}>
            לבירורים ופרטים נוספים ניתן לפנות
            <br />
            <Stack
              direction="row"
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              <LocalPhoneIcon />
              <p> 03-9264855</p>
            </Stack>
          </Typography>
          <HomeButton/>
      </Box>
    </Container>
  );
}

export default ErrorUrl;
